import React from "react";
import styled from "styled-components";
import { certifications, achievements } from "../../data/constants";

const Section = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px 16px 40px;
  position: relative;
  z-index: 1;
`;

const Wrap = styled.div`
  width: 100%;
  max-width: 1100px;
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 20px;

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
`;

const Panel = styled.div`
  background: ${({ theme }) => theme.card};
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 22px;
  padding: 28px 26px;
`;

const Eyebrow = styled.div`
  color: ${({ theme }) => theme.primary};
  letter-spacing: 0.16em;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 700;
`;

const Title = styled.h2`
  margin: 8px 0 18px;
  font-size: 32px;
  color: ${({ theme }) => theme.text_primary};
`;

const List = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Item = styled.li`
  padding: 14px 16px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  color: ${({ theme }) => theme.text_primary};
  transition: transform 0.3s ease, border-color 0.3s ease;

  &:hover {
    transform: translateX(6px);
    border-color: ${({ theme }) => theme.primary};
  }
`;

const Org = styled.div`
  font-weight: 700;
`;

const Detail = styled.div`
  margin-top: 4px;
  color: ${({ theme }) => theme.text_secondary};
  font-size: 14px;
`;

const Credentials = () => {
  return (
    <Section id="credentials">
      <Wrap>
        <Panel>
          <Eyebrow>Training</Eyebrow>
          <Title>Certifications</Title>
          <List>
            {certifications.map((item) => (
              <Item key={item.name}>
                <Org>{item.org}</Org>
                <Detail>{item.name}</Detail>
              </Item>
            ))}
          </List>
        </Panel>
        <Panel>
          <Eyebrow>Highlights</Eyebrow>
          <Title>Achievements</Title>
          <List>
            {achievements.map((item) => (
              <Item key={item}>
                <Org>{item}</Org>
              </Item>
            ))}
          </List>
        </Panel>
      </Wrap>
    </Section>
  );
};

export default Credentials;
